module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am4.6e425f60d193757af3407859fdbf6cc5.png";